// extracted by mini-css-extract-plugin
export default {"body":"product-form_body__aj4Dr"};